import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";

@Injectable()
export class HashtrackService {
    constructor(private httpClient: HttpClient) { }

    private endPoint: string = "/hashtrack";

    async getAllProjects() {
        let response = await this.httpClient.get(`${this.endPoint}/projects`);
        return response;
    }

    async getAllCustomers() {
        let response = await this.httpClient.get(`${this.endPoint}/customers`);
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/hashTrack.service.ts